export default __webpack_public_path__ + "static/media/bankruptcy.5d5791b2.png";